export enum ClientGrantTypeEnum {
    IMPLICIT = 'implicit',
    HYBRID = 'hybrid',
    AUTHORIZATION_CODE = 'authorization_code',
    CLIENT_CREDENTIALS = 'client_credentials',
    RESOURCE_OWNER_PASSWORD = 'password',
    DEVICE_FLOW = 'urn:ietf:params:oauth:grant-type:device_code',
}

export enum ClientProtocolEnum {
    AUTHORIZATION_CODE = 1,
    HYBRID = 2,
    IMPLICIT = 3,
    CLIENT_CREDENTIAL = 4,
    RESOURCE_OWNER_PASSWORD = 5,
    DEVICE_FLOW = 6
}
